import Section from '@app/components/atoms/Section/Section'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { InertiaLink, usePage } from '@inertiajs/inertia-react'
import PageviewIcon from '@mui/icons-material/Pageview'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'

export default function VoucherCampaign() {
  const {
    props: { campaigns, voucher, routeName },
  } = usePage()

  const { t } = useTranslation()

  return (
    <Section simple>
      <DataGrid
        enableIndexColumn
        columns={[
          {
            id: 'name',
            Header: t('CAMPAIGNS.NAME'),
            accessor: 'name',
            type: 'string',
          },
          {
            id: 'partner_name',
            Header: t('CAMPAIGNS.PARTNER'),
            accessor: 'partner_name',
            type: 'string',
            disableFilters: true,
          },
          {
            id: 'used_codes',
            Header: t('CAMPAIGNS.TOTAL_USED'),
            accessor: 'used_codes',
            type: 'number',
            autoHide: true,
          },
          {
            id: 'redeemed_codes',
            Header: t('CAMPAIGNS.TOTAL_REDEEMED'),
            accessor: 'redeemed_codes',
            type: 'number',
            autoHide: true,
          },
          {
            id: 'total_get_code',
            Header: t('CAMPAIGNS.TOTAL_GET_CODES'),
            accessor: 'total_get_code',
            type: 'number',
          },
          {
            id: 'total_cost',
            Header: t('CAMPAIGNS.TOTAL_COST'),
            accessor: 'total_cost',
            type: 'number',
            width: 100,
          },
          {
            id: 'action',
            Header: t('CAMPAIGNS.ACTIONS'),
            disableFilters: true,
            align: 'center',
            cell: {
              style: { whiteSpace: 'nowrap' },
            },
            Cell: ({ row }) => (
              <>
                <IconButton component={InertiaLink} href={route('admin.campaigns.show', row.original.id)}>
                  <PageviewIcon />
                </IconButton>
              </>
            ),
          },
        ]}
        data={campaigns}
        enableCollapseFilter={false}
        params={{ voucher: voucher.id, tab: 'campaigns' }}
        queries={{
          voucher: voucher.id,
          tab: 'campaigns',
        }}
        routeName={routeName}
      />
    </Section>
  )
}
